import { Box, useTheme, Typography } from '@mui/material';
import type { FC } from 'react';

import GoeControllerOutlinedIcon from 'components/Icons/DeviceIcons/GoeControllerOutlinedIcon';
import DevicesIcon from 'components/Icons/DevicesIcon';

export interface DeviceTypeCountProps {
  countChargers: number;
  countControllers: number;
}

const DeviceTypeCount: FC<DeviceTypeCountProps> = ({
  countChargers,
  countControllers,
}) => {
  const theme = useTheme();

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {countChargers ? (
        <Box display="flex" alignItems="center" gap={0.5}>
          <DevicesIcon color="primary" />
          <Typography color="primary">{countChargers}</Typography>
        </Box>
      ) : null}

      {countControllers ? (
        <Box display="flex" alignItems="center" gap={0.5}>
          <GoeControllerOutlinedIcon color={theme.vars.palette.primary.main} />
          <Typography color="primary">{countControllers}</Typography>
        </Box>
      ) : null}
    </Box>
  );
};

export default DeviceTypeCount;
